/**
 * Active data adapter.
 *
 * Currently the workbook adapter (build-time JSON generated from
 * NeuroNeeti_Synthetic_Department_Database.xlsx). Swap this export
 * with a production API adapter without touching any UI code.
 */
import { workbookAdapter } from "./workbookAdapter";

export const activeAdapter = workbookAdapter;
